import { PUT_APP_VERSION } from "../actions/appVersionActions";

const initialState = {
  lastVersion: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PUT_APP_VERSION:
      return {
        ...state,
        lastVersion: action.value,
      };
    default:
      return state;
  }
} // END reducer


// WEBPACK FOOTER //
// ./src/redux/reducers/appVersionReducer.js